module.exports = __webpack_public_path__ + "img/articles.af67fd46.jpg";